<template>
  <div id="share">
    <div class="share_box">
      <div class="share_title">
        <span>分享方式</span>
        <p>长按保存图片或发送给好友</p>
        <!--  <p>2.点击“更多方式”长按保存二维码或复制链接发送给朋友</p> -->
      </div>
      <div class="share_img image_tofile" ref="imageTofile">
        <div class="share_top iconfont">
          <h3>学员一点通用户 — {{$store.state.userInfo.nickname}}</h3>
          <span>邀请您一起开通课程</span>
          <div class="img_01">
            <img :src="imagebase64" />

          </div>
          <h2>{{video.subject}}</h2>
          <p style="display: block;">{{video.description}}</p>
        </div>
        <div class="share_bottom">
          <ul>
            <li class="logo"><span><img src="../assets/logo1.png" /></span>学员一点通</li>
            <li>长按图片识别二维码</li>
            <li>观看考场实景视频</li>
          </ul>
          <div class="share_ewm" id="qrcode" ref="qrcode">
            <!-- <img src="../assets/ewm.png" /> -->
          </div>
        </div>
      </div>
      <img :src="htmlUrl" id="showimage" style="width: 100%;margin: 0px auto; padding: 30px 20px;display: none;">
    </div>
  </div>
</template>

<script>
  import html2canvas from 'html2canvas'
  import QRCode from "qrcodejs2";

  export default {
    name: 'Share',
    data() {
      return {
        video: {},
        htmlUrl: '',
        imagebase64: ''
      }
    },
    components: {
      html2canvas
    },
    methods: {
      loadData() {
        var that = this
        var options = this.$route.query;
        this.$app.pr('/api/video/shareDetail', {
          id: options.id
        }).then((res) => {
          this.video = res.data.video;
          this.imagebase64 = res.data.imagebase64;
          setTimeout(function() {
            that.toImage();
          }, 500);

        }).catch((res) => {
          this.$wx.navigateBack({
            delta: 1
          })
        });
      },
      toImage() {
        // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
        html2canvas(this.$refs.imageTofile, {
          backgroundColor: null
        }).then((canvas) => {
          let url = canvas.toDataURL('image/png');
          this.htmlUrl = url;
          $("#showimage").show();
          $(".image_tofile").hide();
        })
      },
      qrcode() {
        var that = this;
        var options = this.$route.query;
        let qrcode = new QRCode("qrcode", {
          width: 70, // 二维码宽度，单位像素
          height: 70, // 二维码高度，单位像素
          text: 'https://jk.ioccn.com/videodetail?id=' + options.id + '&scene=video_' + that.$store.state.userInfo.id // 生成二维码的链接
        });
      }
    },
    created() {
      this.loadData();

    },
    mounted() {
      this.qrcode();
    },
    beforeRouteEnter(to, from, next) {
        var isIphone = navigator.userAgent.includes('iPhone');
        var isIpad = navigator.userAgent.includes('iPad');

        // 修复iOS版微信h5 History兼容性问题
        if ((isIphone || isIpad) && to.path !== location.pathname) {
          location.assign(to.fullPath); // 此处不可使用location.replace
        } else {
          next();
        }
    }

  }
</script>
<style scoped>
  body {
    background-color: #363853 !important;
  }

  #share {
    background-color: #363853;
    height: 100%;
    color: #fff;
    padding: 20px 10px 56px;
  }

  .share_box .share_title span {
    font-size: 4vw;
    margin-bottom: 10px;
    display: inline-block;
  }

  .share_box .share_title p {
    font-size: 3.5vw;
    line-height: 30px;
  }

  .share_img {
    width: 90%;
    background-image: -webkit-linear-gradient(30deg, rgb(127, 212, 253) 0%, rgb(42, 162, 248) 100%);
    margin: 40px auto;
    padding: 30px 20px;
  }

  .share_top {
    background-color: #fff;
    border-radius: 6px;
    padding: 20px 10px 30px;
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.07);
    position: relative;
  }

  .share_top::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 6px;
    background-color: #ff9018;
    top: 0;
    left: 0;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }

  .share_top::after {
    content: '\e639';
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 100%;
    background-color: #e9f5fd;
    left: 50%;
    margin-left: -15px;
    top: -15px;
    color: #2ba3f8;
    text-align: center;
    line-height: 30px;
  }

  .share_top h3 {
    font-size: 3.5vw;
    color: #333;
    text-align: center;
    margin-top: 10px;
  }

  .share_top span {
    font-size: 3.5vw;
    color: #333;
    text-align: center;
    display: block;
  }

  .share_top .img_01 {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .share_top .img_01 img {
    width: 100%;
    display: block;
  }

  .share_top h2 {
    color: #333;
    font-size: 4vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 6px;
  }

  .share_top p {
    font-size: 3.5vw;
    color: #999;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .share_bottom {
    background-color: #ff9018;
    border-radius: 6px;
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.07);
    padding: 10px;
    margin-top: 20px;
    position: relative;
  }

  .share_bottom ul li {
    font-size: 3.2vw;
    position: relative;
    line-height: 24px;
  }

  .share_bottom ul li.logo {
    line-height: 24px;
    height: 24px;
    display: block;
    padding-left: 28px;
  }

  .share_bottom ul li.logo span {
    display: inline-block;
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -12px;
  }

  .share_bottom ul li.logo span img {
    width: 100%;
    display: block;
  }

  .share_bottom .share_ewm {
    width: 70px;
    height: 70px;
    position: absolute;
    top: 50%;
    margin-top: -35px;
    right: 10px;
  }

  .share_bottom .share_ewm img {
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Share.vue